import { jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect } from 'react';
import { useInternalSideSheetContext } from '../SideSheet.Context/index.es.js';

const SCROLL_EPSILON = 1;
const SideSheetBody = ({ children })=>{
    const { setHasFooterShadow, setHasHeaderShadow } = useInternalSideSheetContext();
    const scrollRef = useRef(null);
    const handleScroll = useCallback(()=>{
        const el = scrollRef.current;
        if (!el) {
            return;
        }
        setHasHeaderShadow(el.scrollTop > 0);
        setHasFooterShadow(el.scrollTop + el.clientHeight < el.scrollHeight - SCROLL_EPSILON);
    }, [
        setHasFooterShadow,
        setHasHeaderShadow
    ]);
    useEffect(()=>{
        const el = scrollRef.current;
        if (!el) {
            return;
        }
        // Set initial shadow
        handleScroll();
        el.addEventListener('scroll', handleScroll);
        return ()=>{
            el.removeEventListener('scroll', handleScroll);
        };
    }, [
        handleScroll
    ]);
    return jsx("div", {
        ref: scrollRef,
        className: "cb-side-sheet-body",
        "data-testid": "side-sheet-body",
        children: children
    });
};
SideSheetBody.displayName = 'SideSheet.Body';

export { SideSheetBody };
//# sourceMappingURL=SideSheet.Body.es.js.map
